/* eslint-disable */
import React from 'react';
import PropTypes, { objectOf } from 'prop-types';
import classNames from 'classnames';
import { orderBy } from 'lodash';
import { getPackagePricing, showOriginalPricing } from 'utils/Pricing';
import FontIcon from 'components/FontIcon';
import { priceFormatter } from 'utils/Numbers';
import BuildChildren from 'utils/BuildChildren';
import CardProductContainer from 'containers/CardProductContainer/CardProductContainer';
import PackageTabBAttribute from './PackageTabBAttribute';
import classes from './PackageTabB.module.scss';

const {
  string,
  arrayOf,
  array,
  shape,
  func,
  number,
} = PropTypes;

const PackageTabB = (props) => {
  const {
    moveLeft,
    moveRight,
    mobileIndex,
    items = [],
    categories = [],
  } = props;

  const gridColumnCount = items.length + 1;
  const gridClassName = `grid${gridColumnCount}Cols`;
  const gridClass = classes[gridClassName];
  const categoryEmptyCells = [];

  const activeInMobile = (index) => index === mobileIndex || index === mobileIndex + 1;

  const getColumnClasses = (index) => {
    const columnClasses = [];

    if ((index % 2 === 0)) {
      columnClasses.push(classes.gridColDark);
    } else {
      columnClasses.push(classes.gridColLight);
    }

    if (!activeInMobile(index)) {
      columnClasses.push(classes.hideInMobile);
    }

    return columnClasses;
  };

  const emptyCell = (columnClasses, key) => (<div className={classNames(classes.gridCell, columnClasses)} key={key} />);

  // The grid is built one row at a time from left to right, top to bottom
  return (
    <div className={classes.container}>
      <div className={classNames(classes.grid, gridClass)}>
        {emptyCell([classes.hideInMobile, classes.gridCellDetails, classes.gridCellBorderBelow])}
        {
          // Create column headers
          items.map((item, index) => {
            const columnClasses = getColumnClasses(index);
            const { products = [] } = item;
            const {
              uniquePrices,
              lowestPriceLowestOriginalPrice,
            } = getPackagePricing(products);
            const lastHeader = items.length === index + 1;

            categoryEmptyCells
              .push(emptyCell(
                [
                  classes.hideInMobile,
                  ...columnClasses,
                ],
                `${item.title}-empty`,
              ));
            return (
              <div
                key={`${item.title}-${index}`}
                className={
                  classNames(
                    classes.sticky,
                    ...columnClasses,
                    `border-${item.tabColor}`,
                    classes.gridCellBorderBelow,
                    classes.gridCell,
                    classes.gridCellColumnHeading,
                    lastHeader ? classes.lastGridCellColumnHeading : '',
                    index === mobileIndex ? classes.gridCellBorderLeftMobile : '',
                  )
                }
              >
                {index + 1 < items.length && mobileIndex + 1 === index &&
                  <div className={classNames(classes.moveRightMobile, classes.sticky)}>
                    <button
                      onClick={moveRight}
                      aria-label='Move Right'
                      type='button'
                      className={classes.movementButton}
                    >
                      <FontIcon icon='far fa-chevron-right' className={classes.movementArrow} />
                    </button>
                  </div>}
                {index > 0 && mobileIndex === index &&
                  <div className={classNames(classes.moveLeftMobile, classes.sticky)}>
                    <button
                      onClick={moveLeft}
                      aria-label='Move Left'
                      type='button'
                      className={classes.movementButton}
                    >
                      <FontIcon icon='far fa-chevron-left' className={classes.movementArrow} />
                    </button>
                  </div>}
                {item.featuredProduct &&
                  <div className={classes.featuredProductWrapper} >
                    <div
                      className={classes.featuredProductLabel}
                      dangerouslySetInnerHTML={{ __html: item.featuredProduct.toUpperCase() }}
                    />
                  </div>
                  }
                {item.packageGridTitle &&
                  <div
                    className={classes.packageGridTitle}
                    dangerouslySetInnerHTML={{ __html: item.packageGridTitle }}
                  />}
                {item.packageGridSubtitle &&
                  <div
                    className={classes.packageGridSubtitle}
                    dangerouslySetInnerHTML={{ __html: item.packageGridSubtitle }}
                  />}
                {products.length > 0 &&
                  <div className={classes.packagePricing}>
                    {uniquePrices.length > 1 &&
                      'Starting at '}
                    {lowestPriceLowestOriginalPrice.price >= 0 && priceFormatter(lowestPriceLowestOriginalPrice.price)}
                    {showOriginalPricing(lowestPriceLowestOriginalPrice) &&
                      <div className={classes.originalPackagePricing}>
                        {priceFormatter(lowestPriceLowestOriginalPrice.originalPrice)}
                      </div>}
                  </div>}
              </div>
            );
          })
        }
        {
          // Create categories
          categories.map((c, index) => ([
            <div
              key={`${c.title}-${index}`}
              className={
                  classNames(
                    classes.gridCellDetails,
                    classes.gridCell,
                    classes.gridCellDetailsCategory,
                    classes.hideInMobile,
                  )
                }
            >
              {c.title &&
              <span>{c.title}</span>}
            </div>,
            categoryEmptyCells,
            // Create attributes
            c.attributes ? c.attributes.map((a, attrIndex) => {
              const lastAttribute = c.attributes.length === attrIndex + 1;
              return ([
                <div
                  key={`${a.title}-${index}`}
                  className={
                      classNames(
                        classes.hideInMobile,
                        classes.gridCellDetails,
                        classes.gridCell,
                        classes.gridCellBorderBelow,
                        lastAttribute ? classes.gridCellLastAttributeRow : '',
                      )
                    }
                >
                  <PackageTabBAttribute
                    title={a.title}
                    displayText={a.displayText}
                    description={a.description}
                    index={attrIndex}
                    image={a.image}
                  />
                  {a.shortCopy &&
                  <div
                    className={classes.gridCellDetailsDescription}
                    dangerouslySetInnerHTML={{ __html: a.shortCopy }}
                  />}
                </div>,
                // Create comparison checkboxes
                items.map((item, itemIndex) => {
                  const columnClasses = getColumnClasses(itemIndex);
                  const checked = item.packageAttributes && item.packageAttributes.includes(a.title);
                  return (
                    <div
                      key={`${a.title}-${itemIndex}`}
                      className={classNames([
                        classes.gridCell,
                        classes.gridCellBorderBelow,
                        ...columnClasses,
                        lastAttribute ? classes.gridCellLastAttributeRow : '',
                        itemIndex === mobileIndex ? classes.gridCellBorderLeftMobile : '',
                      ])}
                    >
                      {attrIndex === 0 && c.title &&
                      <div
                        className={classes.gridCellMobileCategory}
                        dangerouslySetInnerHTML={{ __html: c.title }} />}
                      <div className={classes.gridCellMobileAttribute}>
                        <PackageTabBAttribute
                          title={a.title}
                          displayText={a.displayText}
                          description={a.description}
                          index={attrIndex}
                        />
                      </div>
                      {checked &&
                        <FontIcon title={`Includes ${a.title}`} className={classes.checkBox} icon='far fa-check' />}
                      {!checked &&
                        <FontIcon title={`${a.title} not included`} className={classes.times} icon='far fa-times' />}
                    </div>
                  );
                }),
              ]);
            }) : [],
          ]))
        }
        {emptyCell([classes.hideInMobile, classes.gridCellDetails])}
        {
          // Create products
          items.map((item, index) => {
            const columnClasses = getColumnClasses(index);
            const { products = [] } = item;
            const sortedProducts = orderBy(products, ['price', 'packageGridTitle', 'packageGridSubtitle'], ['desc', 'asc', 'asc']);
            return (
              <div
                key={`${item.title}-${index}`}
                className={
                  classNames(
                    classes.gridCell,
                    ...columnClasses,
                    index === mobileIndex ? classes.gridCellBorderLeftMobile : '',
                  )
                }
              >
                {
                  <div
                    className={classes.gridCellProduct}
                  >
                    <CardProductContainer items={sortedProducts} itemType='CardProductAItem' gridClass={gridClassName} groupByCategory />
                  </div>
                }
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

const PackageTabT = shape({
  packageGridTitle: string,
  packageGridSubtitle: string,
  description: string,
  tabColor: string,
  products: array,
  packageAttributes: arrayOf(string),
});

const AttributeT = shape({
  title: string,
  displayText: string,
  shortCopy: string,
  description: string,
  image: shape({
    url: string,
    altText: string,
  })
});

const CategoryT = shape({
  title: string,
  attributes: arrayOf(AttributeT),
});

PackageTabB.propTypes = {
  moveLeft: func,
  moveRight: func,
  mobileIndex: number,
  items: arrayOf(PackageTabT),
  categories: arrayOf(CategoryT),
};

export default PackageTabB;
